import React from "react";
import { SvgProps } from "./Form";

export const QuestionMarkCircle = (props: SvgProps) => (
  <svg
    {...props}
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5201_11710)">
      <path
        d="M6 10C5.20888 10 4.43552 9.76541 3.77772 9.32588C3.11992 8.88635 2.60723 8.26164 2.30448 7.53074C2.00173 6.79983 1.92252 5.99556 2.07686 5.21964C2.2312 4.44372 2.61216 3.73098 3.17157 3.17157C3.73098 2.61216 4.44372 2.2312 5.21964 2.07686C5.99556 1.92252 6.79983 2.00173 7.53074 2.30448C8.26164 2.60723 8.88635 3.11992 9.32588 3.77772C9.76541 4.43552 10 5.20888 10 6C9.99886 7.06052 9.57706 8.07727 8.82716 8.82716C8.07727 9.57706 7.06052 9.99886 6 10V10ZM6 2.66667C5.34073 2.66667 4.69626 2.86217 4.1481 3.22844C3.59994 3.59471 3.1727 4.1153 2.9204 4.72439C2.66811 5.33348 2.6021 6.0037 2.73072 6.6503C2.85934 7.29691 3.1768 7.89085 3.64298 8.35702C4.10915 8.8232 4.7031 9.14067 5.3497 9.26929C5.9963 9.3979 6.66653 9.33189 7.27561 9.0796C7.8847 8.82731 8.4053 8.40007 8.77157 7.8519C9.13784 7.30374 9.33334 6.65927 9.33334 6C9.33236 5.11624 8.98086 4.26896 8.35595 3.64405C7.73104 3.01914 6.88376 2.66764 6 2.66667V2.66667Z"
        fill="currentColor"
      />
      <path
        d="M6.33317 6.99985H5.6665V6.75219C5.66158 6.51699 5.71969 6.28477 5.83481 6.07962C5.94993 5.87447 6.11786 5.70386 6.32117 5.58552C6.44433 5.51769 6.54288 5.41265 6.60275 5.28543C6.66262 5.15821 6.68073 5.01532 6.6545 4.87719C6.62853 4.74559 6.56391 4.62472 6.46892 4.53002C6.37392 4.43532 6.25285 4.37108 6.12117 4.34552C6.02508 4.32773 5.92625 4.33129 5.83168 4.35594C5.73712 4.38059 5.64913 4.42573 5.57394 4.48816C5.49876 4.55059 5.43822 4.62879 5.39661 4.71721C5.355 4.80564 5.33335 4.90213 5.33317 4.99985H4.6665C4.66659 4.76469 4.72887 4.53373 4.84702 4.3304C4.96518 4.12708 5.13501 3.95862 5.33929 3.84212C5.54356 3.72561 5.77502 3.66521 6.01018 3.66703C6.24533 3.66886 6.47582 3.73284 6.67827 3.8525C6.88071 3.97216 7.04791 4.14323 7.1629 4.34837C7.27789 4.5535 7.33658 4.7854 7.33301 5.02053C7.32945 5.25567 7.26376 5.48568 7.1426 5.68724C7.02145 5.88879 6.84915 6.05472 6.64317 6.16819C6.54475 6.22972 6.46428 6.3161 6.40986 6.41862C6.35544 6.52114 6.32898 6.63619 6.33317 6.75219V6.99985Z"
        fill="currentColor"
      />
      <path
        d="M6.33317 7.6665H5.6665V8.33317H6.33317V7.6665Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_5201_11710">
        <rect width="8" height="8" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
);
